import FormInputs from '../../../components/UI/FormInputs';

const DropDown = (props) => {
    const options = props.field.options.map(item => ({
        label: item.value,
        value: item.id
        }));
        
    return (

        props.tableView === true ?
            <td class="w-25">
                <FormInputs type="CheckboxDropDown" options={options} changeHandler={(opt, isMulti, e) => props.handleChange(props.field.id, isMulti === 1 ? opt.value : [opt.value], isMulti === 1 ? true : false, isMulti === 0 ? true : false)} value={props.value} isMulti={props.field.ismultiselect} />
            </td>
            :
            <div class="col-12">
                <div class="card-header sh_subaccordionheader"><h6 class="text-sm mb-0">{props.field.label}
                    {props.field.is_required && <span className="text-danger">*</span>}
                </h6>
                </div>
                <div class="w-75">
                    <FormInputs type="CheckboxDropDown" options={options} changeHandler={(opt, isMulti, e) => props.handleChange(props.field.id, isMulti === 1 ? opt.value : [opt.value], isMulti === 1 ? true : false, isMulti === 0 ? true : false)} value={props.value} isMulti={props.field.ismultiselect} />
                </div>
            </div>

    )
}

export default DropDown